module.exports = __webpack_public_path__ + "img/895-daef9f.png";